<template>
	<card :type="strAccessType" class="ReBigCardStaff">
		<div class="card-user">
			<div class="left_part">
				<div class="avatarBlk author">
					<div class="photo" v-if="typeof objStaff.code != 'undefined'"><img class="avatar" :src="$GVO.endpoint_domen+'/ajaxdata/getImg.php?code='+objStaff.code" /></div>
					<div class="onlineStatus" :class="[{'online':bOnlineStatus},{'offline':!bOnlineStatus}]">
						<i></i>
						<h5 class="mb-1">{{strOnline}}</h5>
					</div>
					<div class="roles">
						<span class="badge badge-pill badge-success" v-if="objStaff.adm == '1'">Администратор системы</span>
							<template v-if="objStaff.roles_text && objStaff.roles_text.length>0">
							<span class="badge badge-pill badge-success" v-for="role in objStaff.roles_text" :key="role">{{ role }}</span>
						</template>
					</div>
					
					
				</div>
				<div class="fioBlk">
					<h4 class="title">{{strFIO}}</h4>
					<p v-if="!$GVO.isEmpty(objStaff.dateBirth)" class="description"><span class="mr-2">Дата рождения:</span><span>{{$GVO.convertDateFromMysql(objStaff.dateBirth)}}</span></p>
					<p class="description" v-if="!$GVO.isEmpty(objStaff.pozname)">{{objStaff.pozname}}</p>
					<div class="socialBlk my-3">
						<template v-for="(dopContact, dc_index) in arrDopContacts" > 
							<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '32' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-facebook">
								<i class="fab fa-facebook-f"> </i>
							</a>
							<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '36' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-twitter">
								<i class="fab fa-twitter"></i>
							</a>
							<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '31' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-primary">
								<i class="fab fa-vk"></i> 
							</a>
							<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '35' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-warning">
								<i class="fab fa-odnoklassniki"></i>
							</a>
							<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '34' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-primary">
								<i><img class="jj-icon" src="/img/icons/livejournal.svg" alt=""></i>
							</a>
							<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '33' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-google">
								<i class="fab fa-google-plus-g"></i>
							</a>
							<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '37' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-instagram">
								<i class="fab fa-instagram"></i>
							</a>
						</template>
					</div>

					<div>
						<p v-if="!$GVO.isEmpty(objStaff.BossName)" class="description">
							<span class="mr-2">Мой руководитель:</span>
							<router-link :to="'/data/staff/id/'+objStaff.BossCode">{{objStaff.BossName}}</router-link>
						</p>
						<div v-if="objStaff.Deputy.length > 0">
							<p class="mr-2">Заместители:</p>
							<ul class="list-unstyled result-marker">							
								<li  v-for="deputy in objStaff.Deputy" :key="deputy.value">
									<router-link :to="'/data/staff/id/'+deputy.deputy_code" >{{deputy.deputy_fio}}</router-link>
								</li>							
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="right_part">
				<div class="contactsBlk" >
					<h4 class="title">Контакты</h4>
					<p v-if="!$GVO.isEmpty(objStaff.phoneMedia)" class="description"><span class="d-inline-block mr-2">Рекламный тел.</span> <a @click="Call(objStaff.phoneMedia,'STAFF',objStaff.id)" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-ic ic-phone"></i><span>{{objStaff.phoneMedia}}</span></a></p>
					<!-- <p v-if="!$GVO.isEmpty(objStaff.phone)" class="description"><span class="d-inline-block mr-2">Основной тел.</span> <a @click="Call(objStaff.phone,'STAFF',objStaff.id)" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-ic ic-phone"></i><span>{{objStaff.phone}}</span></a></p> -->
					<p v-if="!$GVO.isEmpty(objStaff.LocalPhone)" class="description"><span class="d-inline-block mr-2">Местный тел.</span> <a :href="`tel:${objStaff.LocalPhone}`" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-ic ic-phone"></i><span>{{objStaff.LocalPhone}}</span></a></p>
					<p v-if="!$GVO.isEmpty(objStaff.WorkPhone)" class="description"><span class="d-inline-block mr-2">Рабочий тел.</span> <a :href="`tel:${objStaff.WorkPhone}`" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-ic ic-phone"></i><span>{{objStaff.WorkPhone}}</span> </a></p>
					<!-- <p v-if="!$GVO.isEmpty(objStaff.MobilePhone)" class="description"><span class="d-inline-block mr-2">Мобильный тел.</span> <a @click="Call(objStaff.MobilePhone,'STAFF',objStaff.id)" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-ic ic-phone"></i><span>{{objStaff.MobilePhone}}</span> </a></p> -->
					<p v-if="!$GVO.isEmpty(objStaff.HomePhone)" class="description"><span class="d-inline-block mr-2">Домашний тел.</span> <a :href="`tel:${objStaff.HomePhone}`" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-ic ic-phone"></i><span>{{objStaff.HomePhone}}</span> </a></p>
					<p v-if="!$GVO.isEmpty(objStaff.CorpPhone)" class="description"><span class="d-inline-block mr-2">Корпоративный тел.</span> <a :href="`tel:${objStaff.CorpPhone}`" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-ic ic-phone"></i><span>{{objStaff.CorpPhone}}</span> </a></p>
					<p v-if="!$GVO.isEmpty(objStaff.InternalPhone)" class="description"><span class="d-inline-block mr-2">Внутренний тел.</span> <a @click="Call(objStaff.InternalPhone,'STAFF',objStaff.id)" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-ic ic-phone"></i><span>{{objStaff.InternalPhone}}</span> </a></p>
					<p v-if="!$GVO.isEmpty(objStaff.Fax)" class="description"><span class="d-inline-block mr-2">Факс</span> <a href="#" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-ic ic-phone"></i><span>{{objStaff.Fax}}</span> </a></p>
					<p v-if="!$GVO.isEmpty(objStaff.email)" class="description"><span class="d-inline-block mr-2">E-mail</span> <a :href="`mailto:${objStaff.email}`" class="d-inline-block mr-1 text-primary"><i class="d-inline-block tim-icons icon-email-85"></i><span>{{objStaff.email}}</span> </a></p>
					<div  v-if="arrDopContacts.length >0" >
						<template v-for="(dopContact, dc_index) in arrDopContacts" >
							<p class="description" :key="dc_index" v-if="dopContact.contact_group!='social' ">
								<span class="d-inline-block mr-2">{{strContactType(dopContact)}}</span> 
								
								<a :href="hrefContact(dopContact)" class="d-inline-block mr-1" :class="[{'text-primary':dopContact.contact_group=='email'},{'text-success':dopContact.contact_group!='email'}]">
									<i v-if="dopContact.contact_group=='email'" class="d-inline-block tim-icons icon-email-85"></i>
									<i v-if="dopContact.contact_group=='phone'" class="d-inline-block tim-ic ic-phone"  @click="Call(dopContact.contact_value,'STAFF',objStaff.id)"></i>
									<i v-if="dopContact.contact_group=='web'" class="d-inline-block tim-icons icon-link-72"></i>
									<i v-if="dopContact.contact_group=='messanger'" class="d-inline-block tim-icons icon-send"></i>
									<span>{{dopContact.contact_value}}</span>
								</a>
							</p>
						</template>
						<!-- <div class="col" v-for="(dopContact, dc_index) in dopContacts" >
							<span>{{dopContact.contact_value}}</span>
						</div> -->
						

					</div>
					<!-- <pre>{{objStaff}}</pre> -->
					<!-- <pre>{{dopContacts}}</pre> -->
					<!-- <p class="description"><span class="d-inline-block mr-2">Написать</span> <a href="#" class="d-inline-block mr-1 text-success"><i class="d-inline-block tim-icons icon-send"></i><span>личное сообщение</span> </a></p> -->
				</div>
				<div class="orgBlk">
					<h4 class="title">Подразделение</h4>
					<div class="pr-3" v-if="typeof objStaff.Branch != 'undefined' && objStaff.Branch.allBranchArrRecur.length > 0">
						<ReBranchPrint :masBranch="objStaff.Branch.allBranchArrRecur"/>
					</div>
				</div>
			</div>
		</div>
		<div class="dopInfoBlk mt-3">
			<div></div>
			<div>
				<h4 class="title">Дополнительная информация</h4>
				<div class="dopInfoItem" v-if="!$GVO.isEmpty(objStaff.about)">
					<h4>О себе</h4>
					<p class="prewrap">{{objStaff.about}}</p>
				</div>
				<div class="dopInfoItem" v-if="!$GVO.isEmpty(objStaff.workarea)">
					<h4>Территория работы</h4>
					<p class="prewrap">{{objStaff.workarea}}</p>
				</div>
				<div class="dopInfoItem" v-if="!$GVO.isEmpty(objStaff.appreciate)">
					<h4>Клиенты ценят меня за</h4>
					<p class="prewrap">{{objStaff.appreciate}}</p>
				</div>
				<div class="dopInfoItem" v-if="!$GVO.isEmpty(objStaff.freetime)">
					<h4>Мои интересы</h4>
					<p class="prewrap">{{objStaff.freetime}}</p>
				</div>
				<div class="dopInfoItem" v-if="!$GVO.isEmpty(objStaff.profileName)">
					<h4>Профиль деятельности</h4>
					<p class="prewrap">{{objStaff.profileName}}</p>
				</div>
				<div class="dopInfoItem" v-if="!$GVO.isEmpty(objStaff.motto)">
					<h4>Мой девиз</h4>
					<p class="prewrap">{{objStaff.motto}}</p>
				</div>				
				<!-- <div class="dopInfoItem">
					<h4>Делюсь комиссией?</h4>
					<p v-if="objStaff.ShareTheCommission == '1'">Да</p>
					<p v-else>Нет</p>
				</div> -->
				<div class="dopInfoItem" v-if="!$GVO.isEmpty(objStaff.video)">
					<h4>Видео-заставка </h4>
					<a :href="objStaff.video" target="_blank">Посмотреть видео</a>	
					<!-- <p>{{objStaff.video}}</p> -->
					<!-- <video controls width="auto" class="TicketVideo my-4">
						<source :src="objStaff.video" type="video/webm">
						<source :src="objStaff.video" type="video/mp4">
						Ваш браузер не поддерживает встроенные видео :(
					</video> -->

				</div>
				<div class="dopInfoItem">
					<h4>Подписан на телефонии?</h4>
					<p v-if="objStaff.ExtPhoneCbIn == 1 && objStaff.ExtPhoneCbOut == 1">Да</p>
					<p v-else>Нет</p>
					<base-button type="primary" simple class="tmplt-btn" @click="signUpStaff()">Подписать сотрудника</base-button>
				</div>
				<div class="dopInfoItem" v-if="objStaffExtra && this.bstaffExtraIsShown">
					<h4>Подписан на уведомления в телеграм?</h4>
					<div >
						<p v-if="typeof objStaffExtra[this.objStaff.code] !='undefined' && ( typeof objStaffExtra[this.objStaff.code].telegram_id=='undefined' || objStaffExtra[this.objStaff.code].telegram_id==0 || objStaffExtra[this.objStaff.code].telegram_active==0)">Нет</p>
						<p v-else>Да</p>
					</div>
					<h4>Подписан на уведомления в макс?</h4>
					<div >
						<p v-if="typeof objStaffExtra[this.objStaff.code] !='undefined' && ( typeof objStaffExtra[this.objStaff.code].max_id=='undefined' || objStaffExtra[this.objStaff.code].max_id==0 || objStaffExtra[this.objStaff.code].max_active==0)">Нет</p>
						<p v-else>Да</p>
					</div>
					
				</div>
				

			</div>
		</div>
	</card>
</template>

<script>
	import ReBranchPrint from 'src/our_components/ReBranchPrint.vue';
	export default {
		name: 'ReSearchCardStaffBig',
		components: {
			ReBranchPrint,
		},
		props: {
			objStaff: {
				type: Object,
				default: function () {return {};},
        	},
			arrDopContacts:Array
			
		},
		watch: {
			
		},
		data () {
			return {
				ver: 1,
				strAccessType: 'staffRO',
				//bOnlineStatus: true,
				bIsEditMode: false,
				objSomeObj: {},
				objStaffExtra:{},
				bstaffExtraIsShown: false,
				show:true,
				// componentKey: 0,
			}
		},
		computed: {
			strFIO: function(){
				return [this.objStaff.lastName,this.objStaff.firstName,this.objStaff.fatherName].join(' ');
			},
			bOnlineStatus: function(){
				if(this.objStaff.online == 1){
					return true;
				}
				return false;
			},
			strOnline: function(){
				if(this.bOnlineStatus){
					return 'онлайн';
				}else{
					return 'оффлайн';
				}
			},

		},
		methods: {
			strContactType: function(objContact){
				return this.$GVO.cats.CONTACTS_TYPES[objContact.contact_group].types[objContact.contact_type];
			},
			Call(strPhone,obj_type,obj_id){
				this.$GVO.Call(strPhone,obj_type,obj_id);
			},
			hrefContact(dopContact){
				//console.log(contactType);
				let strHref = '#';
				switch (dopContact.contact_type) {
					case '11'://email
						strHref = 'mailto:'+dopContact.contact_value;
						break;
					case '41'://watsapp
						strHref = 'whatsapp://send?phone='+dopContact.contact_value;
						break;
					case '40'://telegram
						strHref = 'tg://resolve?domain='+dopContact.contact_value;
						break;
					case '42'://viber
						strHref = 'viber://chat?number='+dopContact.contact_value;
						break;
					case '43'://skype
						strHref = 'skype:'+dopContact.contact_value+'?call';
						break;
					case '21'://web
						strHref = dopContact.contact_value;
						break;
				}
				return strHref;
			},		
			signUpStaff(){
				// console.log('signUpStaff and some shit and staff code is ' + this.objStaff.code);

				this.$GVO.ApiCall('SUBSCRIBE_INTERNAL_PHONE',{obj:'staff',flt:{code:this.objStaff.code}})
				.then((objApi) => {
					// console.log(objApi);
					if(objApi.success === true) {
						// location.reload();
						// console.log('signUpStaff and some shit and staff code is ' + this.objStaff.code);
						// this.objSomeObj = objApi.data;
					}
				}).catch(errorObjApi => console.error(errorObjApi));

			},	
			checkTelegram(){
			
				if(typeof this.objStaffExtra[this.objStaff.code] == 'undefined'){
							this.$GVO.ApiCall('staff.GET_STAFF_EXTRA_DATA',{flt:{'code':this.objStaff.code}})
							.then((objApi) => {
								if(objApi.success === true){
									// console.log('objApi.data[0] ' + objApi.data[0]);
									this.objStaffExtra[this.objStaff.code] = objApi.data[0];
									this.bstaffExtraIsShown = true;
								}
							}).catch(errorObjApi => {console.error(errorObjApi);});
						}

				
			},
			// forcefullUpdate() {
			// 	//при изменении значения value из компонета  меняем componentKey, чтобы заапдейтить инстенс
			// 	this.componentKey += 1;
			// 	console.log('this.componentKey ',this.componentKey );
			// },
			// rerender(){
			// 	this.show = false;
			// 	this.$nextTick(() => {
			// 		this.show = true;
			// 		console.log('re-render start');
			// 		this.$nextTick(() => {
			// 			console.log('re-render end');
			// 		})
			// 	})
			// },
		
			
		},
		mounted() {
			
			this.checkTelegram();
		},
	}
</script>
<style scoped>
	.ReBigCardStaff {border: 1px solid #9e77f3;  box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important;}
	.ReBigCardStaff .card-user{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.ReBigCardStaff .card-user [slot='header']{
		position: absolute;
		right:0px;
		top:0px;
	}
	.card-user .left_part, .card-user .right_part{
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
	}
	/*.card-user .left_part{}*/
	.card-user .right_part{justify-content: space-between;}
	.card-user .left_part > *, .card-user .right_part > *{display: inline-block; vertical-align: top;}

	.avatarBlk{width:250px;}
	.avatarBlk .avatar{
		object-fit: contain;
		background-color: white;
	}
	
	.onlineStatus{text-align: center;}
	.onlineStatus > *{display: inline-block;}
	.onlineStatus i{
		width: 7px;
		height: 7px;
		border-radius: 50%;
		margin-right: 5px;
	}
	.onlineStatus.online i{background-color: greenyellow;}
	.onlineStatus.offline i{background-color: red;}

	.socialBlk > *{margin-right: 10px;}

	.fioBlk, .contactsBlk, .orgBlk{margin-top: 35px;}

	p.description{font-size: 1em;}
	p.description a > i{ margin-right: 5px;}
	.title{text-transform: uppercase;}

	.dopInfoBlk{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.dopInfoBlk > div:nth-child(1){width: 250px;}
	.dopInfoBlk > div:nth-child(2){width: calc(100% - 250px);}
	.dopInfoBlk .dopInfoItem{margin-bottom: 15px;}
	.dopInfoBlk .dopInfoItem h4{margin-bottom: 3px; font-weight: bold;}

	.btn-icon .fab{
		position: absolute;
		font-size: 1em;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-12px, -12px);
		transform: translate(-12px, -12px);
		line-height: 1.5626rem;
		width: 24px;
	}
	.roles {
		display: flex;
		flex-direction: column;
		padding: 0 15px 0 5px;
		align-items: center;
	}
	.roles .badge {width: fit-content;}
	
	@media (max-width: 1100px){
		/* .card-user .orgBlk{display:none;} */
		.dopInfoBlk > div:nth-child(1){display: none;}
		.dopInfoBlk > div:nth-child(2){width: 100%;}
	}
	@media (max-width: 800px){
		.ReBigCardStaff .card-user{
			display: block;
		}
		.card-user .left_part, .card-user .right_part{display: block;}
	}

	.jj-icon {
		height: 18px;
		width: 18px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-9px, -9px);
	}
	.telega-container {
		border: 1px dashed #F84E54; border-radius: 6px; padding: 15px; width: 100%;  align-items: center; display: flex; flex-direction: column; 
	}

</style>
